/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import './CurveSelectionMobile.scss';
import { Icon, InputField, NavTabs, Size } from '@vaisala-rockhopper/components';
import { useTranslation } from 'react-i18next';
import AllCurves from './tabs/AllCurves';
import RecentCurves from './tabs/RecentCurves';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { CurveData } from '../../../../modules/ChemicalDataController';

interface CurveSelectionMobileProps {
  allChemicalCurves: CurveData[]
  selectedChemical: number
  onChemicalChanged(id: number): void
  recentChemicals: CurveData[]
}

const CurveSelectionMobile = ({ allChemicalCurves, selectedChemical, onChemicalChanged, recentChemicals }: CurveSelectionMobileProps) => {
  const { t } = useTranslation();

  const [selectedTabKey, setSelectedTabKey] = React.useState('1');
  const [searchValue, setSearchValue] = React.useState("");
  const [sortOrder, setSortOrder] = React.useState("asc");

  const [curves, setCurves] = React.useState<CurveData[]>([]);

  React.useEffect(() => {
    setCurves(allChemicalCurves)
  }, [allChemicalCurves])

  const sortCurves = () => {
    let sortedList = [...curves]
    if (sortOrder === "asc") {
      sortedList.sort((a: any, b: any) => {
        if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
          return -1
        }
        if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
          return 1
        }
        return 0
      })
    } else {
      sortedList.sort((a: any, b: any) => {
        if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
          return -1
        }
        if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
          return 1
        }
        return 0
      })
    }
    setSortOrder(sortOrder === "asc" ? "desc" : "asc")
    setCurves(sortedList)
  }

  React.useEffect(() => {
      const getResults = setTimeout(() => {
        if (searchValue !== "") {
          const filterKeys = ['Name', 'Code', 'Unit', 'Min', 'Max'];
          const data = [...allChemicalCurves]
          const results = data.filter((obj: any)=>{
            return Object.keys(obj).some((key)=>{
              if (filterKeys.includes(key) && obj[key] !== null) {
                return obj[key].toString().toLowerCase().includes(searchValue.toLowerCase());
              }
              return null
            }, false);
          });
          setCurves(results)
        } else {
          setCurves(allChemicalCurves)
        }
      }, 400)

      return () => clearTimeout(getResults)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue])

  return (
    <div className={`curve-selection-mobile ${selectedChemical > -1 ? '' : 'curve-selection--active'} `}>
        <NavTabs
            htmlId={['curve selection']}
            className={'curve-selection-tabs'}
            selectedTabKey={selectedTabKey}
            setSelectedTabKey={setSelectedTabKey}
            onSelectedTabChanged={selectedTabKey => setSelectedTabKey(selectedTabKey)}
        >
          <NavTabs.Tab tabKey="1" title="All curves">
            <div className="search-and-sort-container">
              <InputField
                  name="search"
                  placeholder={t('search.placeholder')}
                  value={searchValue}
                  className={'curve-search-field'}
                  onChange={e => setSearchValue(e.target.value)}
                  width={Size.Container}
                  endIcon={<Icon name={VaiIcon.Search} size={Size.L} />}
              />
              <Icon className={'sort-icon'} name={VaiIcon.ArrowUpAndDown} size={Size.L} onClick={() => sortCurves()}/>
            </div>
            {curves.length > 0 ?
              <AllCurves
                curves={curves}
                onChemicalChanged={onChemicalChanged}
              />
            :
              <div className="no-search-results">
                <p>{t('search.no_match')}</p>
              </div>
            }
          </NavTabs.Tab>
          <NavTabs.Tab tabKey="2" title="Recents">
            <RecentCurves
              recentChemicals={recentChemicals}
              onChemicalChanged={onChemicalChanged}
            />
          </NavTabs.Tab>
        </NavTabs>
    </div>
  );
};
export default CurveSelectionMobile;
